import { render } from "./SidebarNull.vue?vue&type=template&id=e2267342"
const script = {}

import exportComponent from "C:\\Users\\nakagawamizuki\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__